export const ON_SIGNUP_ERROR_MESSAGE = {
  onVerificationError: 'There was an issue with your account information. Please check again.',
};

export const DEFAULT_FIXED_HEADER_HEIGHT = 73;
export const EVERGENT_CAPTCHA_ERROR_CODE = 'eVG1001';
export const CAPTCHA_ERROR_MESSAGE = 'Unable to validate reCAPTCHA, please try again.';
export const ALT_CAPTCHA_ERROR_MESSAGE = 'Something went wrong, please try again later.';

export const FREE_TRIAL_PROMO = '7DAYFREEFN';
export const FIRST_MONTH_99C_PROMO = '1STMONTH99C';
export const FIRST_MONTH_FREE_PROMO = 'FNM230DFREE';
export const MONTHLY_30_DFT_FREE_PROMO = 'MONTHLY30DFT';
export const DISABLE_SHIPPING_ADDRESS_PROMOS = ['FNROKU1', 'SPESTRAUDBK'];
export const SHEER_YEAR_FREE_PROMO = 'SHR1YFREE';
export const MILITARYGIFT_COUPON = 'MILITARYGIFT';
export const MILITARYDEAL_COUPON = 'MILITARYDEAL';

export const MONTHLY_ROKT_SERVICE_ID = 'FOXNATION1M-WEB-ROKT';

// Retention Promo
export const RETENTION_YEAR_PROMO = 'RETENTIONSAVE45OFFRTP';
export const RETENTION_3_MONTHS_PROMO = 'RETENTION99FOR3MORTP';

// Spring 25% Off Promo
export const SPRING_25_OFF_PROMO = 'SPRING25OFF';

//Free Week Promo - TODO: remove unused of thse after special promo plans expire (May 30 2023)
export const FREE_WEEK_SKU = 'FNSWKND2023';
export const YEAR_UPGRADE_SKU = 'FN1YSWND2023';
export const MONTH_UPGRADE_SKU = 'FOXNATION1M-WEB2';
export const MONTH_UPGRADE_SKU_VARIANT = 'FOXNATION1M-WEB4';
export const SILVER_PATRIOT_2_YEAR_SKU = 'FN2YSPNMR2';

// Black Friday Promo from 2022
export const BLACK_FRIDAY_PACKAGE_ID = 'FN1YYLWSTNBF18';
// Holiday Promo from 2022
export const HOLIDAY_2022_PACKAGE_ID = 'FN1YHOLIDAY22';

// Founders Cutoff Date - must be older than date to be founders account
export const FOUNDERS_CUTOFF_DATE = 1543276800000;

// not using yearlyPlanId, because it could change anytime, e.g: FOXNATION12M or FN1YR
export const FOUNDERS_SERVICE_ID = 'FOXNATION12M-WEB';
export const BF_HOLIDAY_RENEWAL_SKU = 'FOXNATION12M-WEB4';
export const restartPlanStatusList = ['Pending Cancel', 'Pending Cancel - Existing', 'Pending Cancel - Trialist'];
export const changePlanStatusList = ['Existing', 'Trialist'];
export const activePlanStatusList = ['Trialist', 'Existing', 'Pending Pause', 'Pause'];

// SheerId
export const SHEER_MILITARY_PACKAGE_ID = 'FNSHR1PA';
export const SHEER_FIRST_RESPONDER_PACKAGE_ID = 'FNSHR1FR';
export const SHEER_FIRST_RESPONDER_MONTHLY_UPGRADE = 'FNFRMO';
export const SHEER_FIRST_RESPONDER_1YR_UPGRADE = 'FNSHR1FRV3';
export const SHEER_FIRST_RESPONDER_2YR_PACKAGE_ID = 'FNSHR1FRV4';
export const SHEER_MILITARY_UPGRADE = 'FNSHR1PAV2';
export const SHEER_MILITARY_UPGRADE_ALT = 'FNSHR1PAV4';
export const SHEER_MILITARY_UPGRADE_CHURNED = 'FNSHR1MO';
export const SHEER_MILITARY_TYPE = 'military';
export const SHEER_FIRST_RESPONDER_TYPE = 'firstResponder';
export const VETERAN_STATUS = 'VETERAN';
export const ACTIVE_DUTY_STATUS = 'ACTIVE_DUTY';
export const RESERVIST_STATUS = 'RESERVIST';
export const POLICE_STATUS = 'POLICE';
export const EMT_STATUS = 'EMT';
export const FIREFIGHTER_STATUS = 'FIREFIGHTER';

// Veterans Advantage/WeSalute
export const VETERANS_ADV_FREE_PROMO = 'FN1YFDPROMO';
export const VA_QUERY_PARAM = 'va_member_id';
export const VA_INITIAL_FREE_YEAR_ID = 'FNVADV1PA';
export const VA_MONTHLY_ID = 'FNVADV1MO';
export const VA_1_YEAR_ID = 'FNVADV1PAV1';
export const VA_2_YEAR_ID = 'FNVADV1PAV2';

// Bango related SKUs
export const VERIZON_SHEER_VERIFICATION_TEST = 'FNVRZTEST1';
export const VERIZON_SHEER_VERIFICATION_MILITARY = 'FNVRZMV';
export const VERIZON_MONTHLY = 'FNVRZ1M2';
export const VERIZON_YEARLY = 'FNVRZPA2';

// Gifting
export const GIFTING_PURCHASE_MODE = 'GIFTING';
export const GIFTING_QUERY_PARAM = 'gifting=true';

// Email Campaign IDs
export const UNSUCCESSFUL_SHEER_VERIFY_EMAIL_ID = 'AH63';
export const FINISH_VERIFYING_SHEER_EMAIL_ID = 'AH11';

export const HIDDEN_PASSWORD_DEFAULT = '*******';

export const MONTHY_PLAN = 'monthly';
export const PATRIOT_PLAN = 'patriot';

export const SHIPPING_FORM_FIELDS = {
  firstName: {
    name: 'firstName',
    label: 'First Name',
  },
  lastName: {
    name: 'lastName',
    label: 'Last Name',
  },
  address1: {
    name: 'address1',
    label: 'Street Address',
  },
  address2: {
    name: 'address2',
    label: 'Apt / Suite / PO Box / Other',
  },
  city: {
    name: 'city',
    label: 'City',
  },
  state: {
    name: 'state',
    label: 'State/Region',
  },
  zipCode: {
    name: 'zipCode',
    label: 'ZIP Code',
  },
};

// Cookies set by CPE team
export const USER_PRIVACY_COOKIE_NAME = 'us_privacy';
export const FNC_COOKIE_NAME = 'traffic_source';
export const FNC_MC_EXPECTED_VALUE = 'FNC_display';

//MVPD
export const MVPD_COOKIE_NAME = 'mvpd-auth';

//from purchaseMode.json
export const MANAGE_PLAN_PURCHASE_MODE = 'MANAGE_PLAN';

// Braze Content Card Zones
export const MY_ACCOUNT_TOP = 'MyAccountTop';
export const MY_ACCOUNT_2ND = 'MyAccount2nd';
export const MY_ACCOUNT_PAGE_TOP = 'MyAccountPageTop';
export const CANCEL_INTERRUPT = 'CancelInterrupt';
export const CANCEL_INTERRUPT_SUCCESS = 'CancelInterruptSuccess';

export const BRAZE_ZONES = [
  MY_ACCOUNT_TOP,
  MY_ACCOUNT_2ND,
  MY_ACCOUNT_PAGE_TOP,
  CANCEL_INTERRUPT,
  CANCEL_INTERRUPT_SUCCESS,
];

// Braze Content Card Campaign Types
export const BANNER = 'Banner';
export const CAPTIONED_IMAGE = 'CaptionedImage';

// SKUs that have free trials that don't expire immediately
export const IMMEDIATE_CANCEL_EXCEPTION_SKUS = [
  'FOXNATION1M-WEB7',
  'FOXNATION12M-WEB',
  'FN2YSPNMR2',
  'FOXNATION1M-WEB-ROKT',
  'FN1YJUSTICE2024',
];
